<script lang="ts">
	import { page } from '$app/stores';
	import NotFound from '$lib/components/Error/NotFound.svelte';
	import LightHouse from '$lib/components/Error/LightHouse.svelte';
</script>

{#if $page.status == 404}
	<NotFound />
{:else}
	<main>
		<div class="container">
			<div class="lighthouse">
				<LightHouse />
			</div>
			<h2>vctraceid: {$page.error?.vctraceid}</h2>
			<h2>Error: {$page.status} {$page.error?.message}</h2>
			<p>An error occurred while rendering this page.</p>
			<p>
				You may want to try again later, or{' '}
				<a href="mailto:support@alida.com">email technical support</a>.
			</p>
		</div>
	</main>
{/if}

<style>
	main {
		display: flex;
		align-items: center;
		justify-content: center;
		block-size: 100vh;
	}

	h2 {
		padding: 10px;
		background-color: gainsboro;
	}

	.container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.lighthouse {
		block-size: 30vh;
		inline-size: 30vh;
	}

	p {
		font-size: 14px;
	}
</style>
